module.exports = __webpack_public_path__ + "img/green-energy.ebcbd138.svg";